import React from 'react';
import DynamicLayout from '../../components/DynamicLayout';
import ContactForm from '../../components/ContactForm';

const ContactPage = () => {
  return (
    <DynamicLayout>
      <div 
        className="full-screen-image-container hundredminnavdesktop margin-top-0"
        style={{
          backgroundImage: `url('/img/saturnwallpaper.jpg')`,
        }}
      >
        <ContactForm />
      </div>
    </DynamicLayout>
  );
};

export default ContactPage;
